export default __webpack_public_path__ + "static/media/segre29.5215b9e4.jpg";